import Vue from 'vue'
import App from './App.vue'
import VueMq from 'vue-mq'
import FloatingVue from 'floating-vue'

Vue.use(VueMq,{
  breakpoints: {
    sm: 420,
    md: 870,
    lg: Infinity,
  }
})
Vue.config.productionTip = false

Vue.use(FloatingVue, {
  defaultTrigger: 'hover focus click touch'
})

new Vue({
  render: h => h(App),
}).$mount('#faz-energy-widget')
